<template>
  <v-card
    class="fill-height text-center"
    :width='isMobile?"":350'
    tile
    flat
    :color="color" v-intersect="{
            handler: onIntersect,
            options: {
              threshold: [0, 0.5, 1.0]
            }
          }"
  >
    <v-row class="pt-12 pa-0 ma-0" justify="center">
      <v-avatar size="120" height="60" class="pa-0">
        <v-img style="filter: invert(100%) contrast(150%);" :src="imgSrc"></v-img>
      </v-avatar>
    </v-row>
    <v-card-text
      v-for="content in contents"
      :key="content"
      class="white--text my-0 py-0 title font-weight-regular"
    >{{ content }}</v-card-text>
    <a :href="jumpTo" class="theme--darkt" style="text-decoration:none;">
      <v-card-text class="d-flex d-sm-none white--text">{{ desc }}</v-card-text>
    </a>
    <v-card-actions >
        <v-row justify="center" class="px-0 mx-0">
          <v-slide-x-transition>
          <v-btn :to="jumpTo"
            v-if="showBtn"
            width="200"
            large
            class="white--text"
            outlined
            tile
          >{{ $t('service.detailBtn') }}</v-btn>
          </v-slide-x-transition>
        </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "TciSlideBtnCard",
  data: () => ({
    showBtn: false,
    isMobile: false
  }),
  props: {
    color: String,
    imgSrc: String,
    contents: Array,
    jumpTo: String,
    desc: String
  },
  methods: {
    onIntersect: function(entries){
      if(!this.showBtn){
        this.showBtn = entries[0].intersectionRatio >= 0.9;
      }
    }
  },
  mounted() {
    this.isMobile = this.$vuetify.breakpoint.xs;
  }
};
</script>

<style scoped>
.v-btn:hover:before {
  opacity: 0.5;
}
</style>
